import CardGridHeader from './header';

export default CardGridHeader;